import { useTranslation } from 'react-i18next';

export default function CommonInfo() {
  const { t } = useTranslation();
  const icons = [
    'ri-calendar-check-line',
    'ri-time-line',
    'ri-group-line',
    'ri-bank-line',
  ];
  const itemKeys = ['item1', 'item2', 'item3', 'item4'] as const;

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-10">
          {String(t('courses.commonInfo.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('courses.commonInfo.title')}
          </h2>
          {String(t('courses.commonInfo.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="space-y-4">
          {itemKeys.map((key, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 p-4 bg-background-100/60 border border-background-200/60"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0 mt-0.5">
                <i className={`${icons[idx]} text-accent-600 text-sm`}></i>
              </div>
              <p className="text-[15px] text-foreground-600 tracking-[0.04em] leading-relaxed pt-1">
                {t(`courses.commonInfo.${key}`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}